(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-slide-panel]').forEach(function(btn){
      btn.addEventListener('click', function(){
        let panelId = btn.getAttribute('data-slide-panel');
        document.getElementById(panelId).classList.add('active');
      });
    });
    document.querySelectorAll('[data-close-panel]').forEach(function(btn){
      btn.addEventListener('click', function(){
        let panelId = btn.getAttribute('data-close-panel');
        document.getElementById(panelId).classList.remove('active');
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
